/**
 * @description - This should be used in change-phone-number store module
 * and any components that need to check the error types thrown by some actions in the module
 */
const CPN_ERROR_TYPES = {
  ktp_invalid: {
    name: 'ktp_invalid',
    message: 'Gambar KTP tidak terbaca sistem. Coba kirim ulang & pastikan gambar cukup jelas, ya',
  },
  selfie_invalid: {
    name: 'selfie_invalid',
    message: 'Gambar swafoto tidak terbaca sistem. Coba kirim ulang & pastikan gambar cukup jelas, ya',
  },
  ktp_and_selfie_validation_api_error: {
    name: 'ktp_and_selfie_validation_api_error',
    message: 'Terjadi kesalahan sistem saat validasi KTP dan selfie. Mohon dicoba beberapa saat lagi.',
  },
  document_unsupported_unclear: {
    name: 'document_unsupported_unclear',
    message: 'Dokumen pendukung tidak terbaca sistem. Coba kirim ulang & pastikan gambar cukup jelas, ya.',
  },
  supporting_document_validation_api_error: {
    name: 'supporting_document_validation_api_error',
    message: 'Terjadi kesalahan sistem saat validasi Dokumen Pendukung. Mohon dicoba beberapa saat lagi.',
  },
  automatic_change_phone_number_error: {
    name: 'automatic_change_phone_number_error',
    message: 'Gagal mengganti nomor telepon',
  },
};

export default CPN_ERROR_TYPES;
